
import "./AppLayout.css";

import Topbar from "./Topbar/Topbar";

export default function AppLayout({
  user,
  sidebar,
  children,
}) {
  return (
    <div className="app-layout">
      <Topbar user={user} />

      <div className="app-layout__body">
        {sidebar}

        <main className="app-layout__content">
          {children}
        </main>
      </div>
    </div>
  );
}
